import { onCleanup } from "solid-js";
import { VIDEOS, type VideoId } from "~/components/marketing/content";
import { useMarketingVideo } from "./context";

/**
 * Where a video sits inline on a page: an empty box shaped like the video, placed by `class`.
 * The layout's player lays the video over it, and docks it in the corner once the slot scrolls
 * mostly out of view, leaving whatever is under the box visible again.
 */
export const VideoSlot = (props: { id: VideoId; class: string }) => {
  const video = useMarketingVideo();
  let slot: { id: VideoId; el: HTMLElement } | undefined;
  onCleanup(() => video.setSlot((current) => (current === slot ? undefined : current)));
  return (
    <div
      // Registered during render, not onMount, so the player's first placement already sees the
      // slot instead of docking for a frame and flying back.
      ref={(el) => {
        slot = { id: props.id, el };
        video.setSlot(slot);
      }}
      aria-hidden="true"
      class={`pointer-events-none scroll-mt-24 ${props.class}`}
      style={{ "aspect-ratio": `${VIDEOS[props.id].width} / ${VIDEOS[props.id].height}` }}
    />
  );
};
